import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { Store } from '../../defaultState';

import { NotificationStateT } from 'types';

const toastsSelector = (state: Store): NotificationStateT => state.notifications;

export const selectorToasts = createDraftSafeSelector(toastsSelector, state => state.toasts);
